import {
    createStore,
    applyMiddleware,
    compose,
    combineReducers
} from 'redux';
import thunk from 'redux-thunk';
import MessageReducer from 'js/modules/message/reducers/MessageReducer';
import appReducer from 'js/app/reducers/AppReducer';
import queryDataReducer from 'js/modules/querydata/reducers/QueryDataReducer';
import IssueConfigReducer from 'js/modules/issue/reducers/IssueConfigReducer';
import CardTypeConfigReducer from 'js/modules/cardTypeConfig/reducers/CardTypeConfigReducer';
import outlookConfigReducer from 'js/modules/outlookPluginConfig/reducers/OutlookConfigReducer';
import AppHeaderReducer from 'js/modules/header/reducer/AppHeaderReducer';

const rootReducer = combineReducers({
    messageData: MessageReducer,
    appData: appReducer,
    querydata: queryDataReducer,
    issueConfig: IssueConfigReducer,
    cardTypeConfig: CardTypeConfigReducer,
    outlookConfig: outlookConfigReducer,
    headerData: AppHeaderReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore( rootReducer, composeEnhancers( applyMiddleware(thunk) ) );

export default store;